// extracted by mini-css-extract-plugin
export default {"form":"FormSendGmail_form__VdH0q"};